import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=2ed04ed1&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
import style0 from "./Table.vue?vue&type=style&index=0&id=2ed04ed1&prod&lang=css"
import style1 from "./Table.vue?vue&type=style&index=1&id=2ed04ed1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed04ed1",
  null
  
)

export default component.exports